import { IPhatHanhDichVuMultipleRequest } from "../../../model/request/hoa-don-dien-tu/IPhatHanhDichVuMultipleRequest";
import { IDichVuHoSo } from "../../../model/respone/dich-vu/IDichVuHoSo";
import { IDichVuHoSoVm } from "../../../model/respone/dich-vu/IDichVuHoSoVm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDichVuHoSoActionsObj = {
  LOAD_START: 0,
  LOAD_SUCCESS: {} as IDichVuHoSoVm[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDichVuHoSoVm,
  SAVE_SUCCESS: {} as IDichVuHoSoVm,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  DELETE_MANY_START: [] as number[],
  DELETE_MANY_SUCCESS: undefined,
  DELETE_MANY_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IDichVuHoSoVm,
  CLOSE_EDIT_MODAL: undefined,

  SHOW_HIDE_IMPORT_MODAL: false,

  IMPORT_START: {} as FormData,
  IMPORT_SUCCESS: undefined,
  IMPORT_ERROR: "",
  SELECTED_ID: [] as number[],
};
export const eDichVuHoSoActionIds = generateActionTypeIds(
  eDichVuHoSoActionsObj,
  "DICH_VU_HO_SO",
);
export type IDichVuHoSoActionTypes = IGenericActionType<
  typeof eDichVuHoSoActionsObj,
  "DICH_VU_HO_SO"
>;
